import React from 'react';
import OpsText from "../../ops-library/ops-text";
import {useNavigate} from "react-router-dom";
import truncate from "../../functions/truncate";

const ArticlePreview = ({article}) => {
    const navigate = useNavigate()

    return (
        <div className="desktop-row-phone-col prew-container-big gap-2 pointer-cursor"
             onClick={() => {
                 navigate(`/aktuality/${article._id}`)
             }}>
            <div className="prew-img-big h-100">
                <img src={`${process.env.REACT_APP_API_BASE_URL}/${article.coverImg}`}
                     className="w-100 h-100 object-fit-cover overflow-hidden" alt=""/>
            </div>
            <div className="prew-content-big fa-flex-col overflow-auto">
                <OpsText type="title2" weight={700} color="color-1 mb-0" alignment="left"
                         content={article?.title}/>

                <OpsText type="normal2" weight={300} color="color-1" alignment="left"
                         content={truncate(article?.subtitle)}/>
            </div>
        </div>
    );
};

export default ArticlePreview;